import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ApiClientService,
  IBookableService,
  IBookableServiceListParams,
  ICreateBookableServicePayload,
  IPaginatedResponse,
  IUpdateBookableServicePayload,
  TENANT_API
} from '@pharvio/core/shared';
import { Observable } from 'rxjs';
import { BookableServicesDataService } from './repositories/bookable-services-data.service';

@Injectable()
export class HttpBookableServicesDataService extends BookableServicesDataService {
  private readonly api = inject(ApiClientService);

  getServices(
    params: IBookableServiceListParams = {}
  ): Observable<IPaginatedResponse<IBookableService>> {
    let httpParams = new HttpParams();
    // Booleans are only sent when set: an explicit `false` is a real filter
    // ("deactivated only"), while `undefined` has to mean "either".
    if (params.page) httpParams = httpParams.set('page', params.page);
    if (params.size) httpParams = httpParams.set('size', params.size);
    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.isActive !== undefined) {
      httpParams = httpParams.set('isActive', params.isActive);
    }
    if (params.sellableOnline !== undefined) {
      httpParams = httpParams.set('sellableOnline', params.sellableOnline);
    }
    if (params.branchId) {
      httpParams = httpParams.set('branchId', params.branchId);
    }

    return this.api.get<IPaginatedResponse<IBookableService>>(
      TENANT_API.BOOKABLE_SERVICES.BASE,
      httpParams
    );
  }

  getService(id: string): Observable<IBookableService> {
    return this.api.get<IBookableService>(
      TENANT_API.BOOKABLE_SERVICES.BY_ID(id)
    );
  }

  createService(
    payload: ICreateBookableServicePayload
  ): Observable<IBookableService> {
    return this.api.post<IBookableService>(
      TENANT_API.BOOKABLE_SERVICES.BASE,
      payload
    );
  }

  updateService(
    id: string,
    payload: IUpdateBookableServicePayload
  ): Observable<IBookableService> {
    return this.api.patch<IBookableService>(
      TENANT_API.BOOKABLE_SERVICES.BY_ID(id),
      payload
    );
  }

  deleteService(id: string): Observable<void> {
    return this.api.delete<void>(TENANT_API.BOOKABLE_SERVICES.BY_ID(id));
  }
}
